import { FC, useEffect, useRef, useState } from "react";
import { Box, Button } from "@mui/material";
import { styles } from "./stylesConfirmation";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  useConfirmChangeEmailMutation,
  useRegisterUserMutation,
  useRegisterUserWithAvatarMutation,
  useResendVerificationMutation,
} from "@/store/api/authApi";
import SetNewPasswordModal from "@/components/UI/modal/Wallet/SetNewPasswordModal";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { setToken } from "@/helpers/cookiesHelper";
import { setAuthData } from "@/store/slice/authSlice";
import { resetSignUpData } from "@/store/slice/signUpSlice";
import OtpForm from "./OtpForm";

const Confirmation: FC = () => {
  const navigate = useNavigate();

  const { type } = useParams();
  const location = useLocation();
  const [resendVerification] = useResendVerificationMutation();
  const signUpData = useSelector((state: RootState) => state.signUp);
  const [resendCooldown, setResendCooldown] = useState(0);

  const queryParams = new URLSearchParams(location.search);
  const queryType = queryParams.get("type");
  const token = queryParams.get("token");
  const [confirmChangeEmail] = useConfirmChangeEmailMutation();

  const inputsRef = useRef<HTMLInputElement[]>([]);
  const email = location.state?.email ?? signUpData.email;

  const dispatch = useAppDispatch();
  const [registerUser] = useRegisterUserMutation();
  const [registerUserWithAvatar] = useRegisterUserWithAvatarMutation();
  const avatar = signUpData.avatar;

  const handlePasswordReset = async () => {
    console.log("\x1b[31m%s\x1b[0m", "handlePasswordReset");
  };
  const handleChangeEmailOtp = async () => {
    if (!token) return;

    try {
      const res = await confirmChangeEmail({ token }).unwrap();

      console.log("Email change confirmed, OTP sent to new email:", res);
    } catch (e) {
      console.error("Confirm change email failed", e);
      throw e;
    }
  };
  const emailResend = location.state?.email ?? signUpData.email;

  const handleResendChangeEmail = async () => {
    if (!emailResend) return;
    await resendVerification({ email: emailResend }).unwrap();
  };

  useEffect(() => {
    if (resendCooldown === 0) return;

    const interval = setInterval(() => {
      setResendCooldown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [resendCooldown]);

  useEffect(() => {
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, []);

  useEffect(() => {
    const isVerifyEmailStep = queryType === "email_verify" || type === "verify-email";
    if (isVerifyEmailStep && !signUpData.email && !signUpData.registrationCode) {
      navigate("/signup", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToSignUp = () => {
    navigate("/signup", {
      state: { step: 4, email: signUpData.email },
    });
  };

  const handleOtpVerified = async (otpCode: string) => {
    try {
      const registrationData: any = { ...signUpData, otp: otpCode };
      let response;
      if (avatar) {
        const formData = new FormData();
        Object.entries(registrationData).forEach(([key, value]) => {
          if (value instanceof File) return;
          formData.append(key, String(value ?? ""));
        });
        formData.append("avatar", avatar);
        response = await registerUserWithAvatar(formData).unwrap();
      } else {
        response = await registerUser(registrationData).unwrap();
      }
      setToken(response.token);
      dispatch(setAuthData({ user: response.user }));
      dispatch(resetSignUpData());
      navigate("/");
    } catch (err) {
      console.error("Registration failed:", err);
      throw err;
    }
  };
  const handleResend = async () => {
    console.log(321);

    if (!emailResend) return;
    await resendVerification({ email: emailResend }).unwrap();
  };

  return (
    <Box sx={styles.wrapper}>
      {(queryType === "email_verify" || type === "verify-email") && (
        <OtpForm
          email={email}
          onSubmit={handleOtpVerified}
          onResend={handleResend}
          onHeaderClick={goToSignUp}
        />
      )}
      {type === "change-email" && token && (
        <OtpForm
          email={"your new email"}
          onSubmit={handleChangeEmailOtp}
          onResend={handleResendChangeEmail}
          onHeaderClick={goToSignUp}
        />
      )}

      {type === "password" && (
        <Button variant="contained" onClick={handlePasswordReset}>
          Confirm Password Reset
        </Button>
      )}
      {queryType === "password_reset" && token && <SetNewPasswordModal token={token} />}
    </Box>
  );
};

export default Confirmation;
